import React from 'react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <section className="w-full bg-ink-deep px-4 py-16" data-id="element-125" data-mp="3mts0qdr2gn4i">
      <div className="mx-auto w-full max-w-xl text-center" data-id="element-126" data-mp="3mt8tbqz1lh4q">
        <h2 className="font-display text-[28px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-127" data-mp="3rsbmoe5ntywv">
          Ready to Stop Guessing and Start{' '}
          <span className="italic text-gold-light" data-id="element-128" data-mp="3drsjbkc53h11">Deciding With Confidence</span>?
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-white/75" data-id="element-129" data-mp="3hw097kuc330u">
          Any complex case that walks into your clinic… you’ll finally know exactly what to do.
        </p>

        <div className="mt-8 rounded-3xl border-2 border-gold bg-white p-6" data-id="element-130" data-mp="38usbp4zn667t">
          <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-131" data-mp="1239o3p9dtm5t">
            Today’s price
          </p>
          <p className="mt-1 font-display text-5xl font-extrabold text-ink sm:text-6xl" data-id="element-132" data-mp="17245cmrpb2nt">
            $27 <span className="text-lg font-bold text-ink-soft" data-id="element-133" data-mp="q7c3onb0s07v">USD</span>
          </p>
          <p className="mt-1 text-[13px] text-ink-soft line-through" data-id="element-134" data-mp="l8hdv1emxbe9">Real value $394 USD</p>
          <p className="mt-2 text-[13px] font-semibold text-emerald-700" data-id="element-135" data-mp="z17096y2sibw">
            🌎 Currency conversion is applied automatically
          </p>

          <div className="mt-5" data-id="element-136" data-mp="v1gbf8s40ca0">
            <CTAButton label="GET INSTANT ACCESS NOW" note="Instant download · One-time payment · Lifetime access · 7-day guarantee" data-id="element-137" data-mp="7999zv7j1f3q" />
          </div>

          <Countdown data-id="element-138" data-mp="ga7hwol366rl" />
          <ScarcityBar data-id="element-139" data-mp="gapk01ufjf7f" />
        </div>
      </div>
    </section>;
}